import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {AllowedPageSizes} from '../../../../../const/constants';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import { Button } from 'devextreme-react/button';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const LocationSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const childRef = useRef();
   
    const gridKey = "795C344B-EBA7-44EB-8BAE-784EEFDF3B67";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const onSelectionChanged = ({ selectedRowsData }) => {
        const selectedRowData = selectedRowsData[0];
        if (childRef.current) {
            childRef.current.updateData(selectedRowData);
        }
    };

    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
                onSelectionChanged={onSelectionChanged}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <ColumnHeaderFilter />
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
               
                <Scrolling mode="virtual" />
                <Column dataField="warehouse" caption="Warehouse" visible={true} />
                <Column dataField="locationCode" caption="Location" visible={true} />
                <Column dataField="locationDescription" caption="Location Description" visible={true} />
                <Column dataField="statusLocation" caption="Status" visible={true} />
                <Column dataField="classLocation" caption="Class Location" visible={true} />
                <Column dataField="subclassLocation" caption="Subclass Location" visible={true} />
                <Column dataField="heightLocation" caption="Height" visible={false} />
                <Column dataField="widthLocation" caption="Width" visible={false} />
                <Column dataField="depthLocation" caption="Depth" visible={false} />
                <Column dataField="code1_Location" caption="Code 1" visible={false} />
                <Column dataField="code2_Location" caption="Code 2" visible={false} />
                <Column dataField="code3_Location" caption="Code 3" visible={false} />
                <Column dataField="code4_Location" caption="Code 4" visible={false} />
                <Column dataField="code5_Location" caption="Code 5" visible={false} />
                <Column dataField="code6_Location" caption="Code 6" visible={false} />
                <Column dataField="code7_Location" caption="Code 7" visible={false} />
                <Column dataField="code8_Location" caption="Code 8" visible={false} />
                <Column dataField="code9_Location" caption="Code 9" visible={false} />
                <Column dataField="code10_Location" caption="Code 10" visible={false} />
                <Column dataField="ref1_Location" caption="Ref 1" visible={false} />
                <Column dataField="ref2_Location" caption="Ref 2" visible={false} />
                <Column dataField="ref3_Location" caption="Ref 3" visible={false} />
                <Column dataField="ref4_Location" caption="Ref 4" visible={false} />
                <Column dataField="ref5_Location" caption="Ref 5" visible={false} />
                <Column dataField="ref6_Location" caption="Ref 6" visible={false} />
                <Column dataField="ref7_Location" caption="Ref 7" visible={false} />
                <Column dataField="ref8_Location" caption="Ref 8" visible={false} />
                <Column dataField="ref9_Location" caption="Ref 9" visible={false} />
                <Column dataField="ref10_Location" caption="Ref 10" visible={false} />
                <Column dataField="date1_Location" caption="Date 1" visible={false} />
                <Column dataField="date2_Location" caption="Date 2" visible={false} />
                <Column dataField="date3_Location" caption="Date 3" visible={false} />
                <Column dataField="date4_Location" caption="Date 4" visible={false} />
                <Column dataField="date5_Location" caption="Date 5" visible={false} />
                <Column dataField="date6_Location" caption="Date 6" visible={false} />
                <Column dataField="date7_Location" caption="Date 7" visible={false} />
                <Column dataField="date8_Location" caption="Date 8" visible={false} />
                <Column dataField="date9_Location" caption="Date 9" visible={false} />
                <Column dataField="date10_Location" caption="Date 10" visible={false} />
                <Column dataField="qty1_Location" caption="Qty 1" visible={false} />
                <Column dataField="qty2_Location" caption="Qty 2" visible={false} />
                <Column dataField="qty3_Location" caption="Qty 3" visible={false} />
                <Column dataField="qty4_Location" caption="Qty 4" visible={false} />
                <Column dataField="qty5_Location" caption="Qty 5" visible={false} />
                <Column dataField="qty6_Location" caption="Qty 6" visible={false} />
                <Column dataField="qty7_Location" caption="Qty 7" visible={false} />
                <Column dataField="qty8_Location" caption="Qty 8" visible={false} />
                <Column dataField="qty9_Location" caption="Qty 9" visible={false} />
                <Column dataField="qty10_Location" caption="Qty 10" visible={false} />
                <Toolbar>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationSubTab);